import React from 'react';

interface RoleBadgeProps {
  role: string;
  size?: 'sm' | 'md' | 'lg';
}

export default function RoleBadge({ role, size = 'md' }: RoleBadgeProps) {
  const roleConfig = {
    'Super Admin': {
      bgColor: 'bg-purple-100',
      textColor: 'text-purple-800',
      borderColor: 'border-purple-200',
      icon: '👑'
    },
    'Admin': {
      bgColor: 'bg-blue-100',
      textColor: 'text-blue-800',
      borderColor: 'border-blue-200',
      icon: '⚡'
    },
    'Editor': {
      bgColor: 'bg-green-100',
      textColor: 'text-green-800',
      borderColor: 'border-green-200',
      icon: '✏️'
    },
    'Viewer': {
      bgColor: 'bg-gray-100',
      textColor: 'text-gray-800',
      borderColor: 'border-gray-200',
      icon: '👁️'
    }
  };

  const config = roleConfig[role as keyof typeof roleConfig] || roleConfig['Viewer'];

  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1.5 text-sm',
    lg: 'px-4 py-2 text-base'
  };

  return (
    <span 
      className={`
        ${config.bgColor} 
        ${config.textColor} 
        ${config.borderColor}
        ${sizeClasses[size]}
        font-medium 
        rounded-full 
        border 
        inline-flex 
        items-center 
        gap-1
      `}
    >
      <span className="text-xs">{config.icon}</span>
      {role}
    </span>
  );
} 